import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Sidebar from "../../Component/Sidebar";
import NewForm from "react-bootstrap/Form";
import TopBar from "../../Component/TopBar";
import "./index.css";
import { navigateTo } from "../../utils/navigation";
import {
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Typography,
  DatePicker,
  TimePicker,
  Switch,
  Button,
  message,
} from "antd";
import moment from "moment";
import { Upload } from "antd";
import dummy_user from "../../assets/images/dummy_user.png";
import edit_profile_icon from "../../assets/images/edit_profile_icon.png";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrganisationData } from "../../redux/api/Organisation";
import { updateProfile } from "../../redux/api/Organisation/update";
import { uploadFile } from "../../redux/api/Upload/Image";
import { createProfile } from "../../redux/api/Organisation/createUser";
export default function Index() {
  const [form] = Form.useForm();
  const [messageForm] = Form.useForm();
  const [educationForm] = Form.useForm();
  const [formCreate] = Form.useForm();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("Update Profile");
  const [image, setImage] = useState(null);
  const [updateImgUrl, setUpdateImgUrl] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [about, setAbout] = useState(null);
  const [education, setEducation] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [degree, setDegree] = useState(null);

  const [userImage, setUserImage] = useState(dummy_user);
  const [createImage, setCreateImage] = useState(dummy_user);
  const [createUserImgUrl, setCreateUserImgUrl] = useState(null);
  const onFinish = (values) => {
    try {
      let userData;
      if (updateImgUrl === null) {
        userData = JSON.stringify({
          firstName: values.firstname,
          lastName: values.lastname,
          email: values.email,
          location: values.location,
          mobile_number: values.phone,
        });
      } else {
      }

      dispatch(updateProfile(userData)).then((res) => {
        if (res.payload.status === "success") {
          getProfile();
          message.success("Profile Updated");
          navigateTo("/dashboard");
        } else {
          message.success("Something went wrong");
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const updateData = () => {
    if (firstName === null) {
      message.error("Please provide firstname");
    } else if (lastName === null || lastName === undefined) {
      message.error("Please provide lastname");
    } else if (email === null || lastName === undefined) {
      message.error("Please provide email");
    } else if (city === null || city === undefined) {
      message.error("Please provide city");
    } else if (state === null || state === undefined) {
      message.error("Please provide firstname");
    } else if (about === null || about === undefined) {
      message.error("Please provide about");
    } else if (education === null || education === undefined) {
      message.error("Please provide Specialiazation");
    } else {
      let userData = JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        email: email,
        city: city,
        state: state,
        about: about,
        specialization: education,
        imageUrl: createUserImgUrl,
        degree: degree,
        mobile_number: phone,
      });
      dispatch(updateProfile(userData)).then((res) => {
        //  console.log("res=====", res);
        if (res.payload.status === "success") {
          getProfile();
          message.success("Profile Updated");
          navigateTo("/dashboard");
        } else {
          message.error(res.payload.message.payload);
        }
      });
    }
  };

  const getProfile = () => {
    dispatch(getOrganisationData()).then((res) => {
      console.log("res", res.payload);
      if (res.payload.status === "success") {
        let resData = res.payload.message.payload;
        form.setFieldsValue({
          firstname: resData.firstName,
          lastname: resData.lastName,
          email: resData.email,

          phone: resData.mobile,
          location: resData.location,
          userId: resData.pcUserId,
          city: resData.city,
          state: resData.state,
        });
        messageForm.setFieldsValue({
          about: resData.about,
        });
        educationForm.setFieldsValue({
          education: resData.specialization,
          degree: resData.degree,
        });
        setFirstName(resData.firstName);
        setLastName(resData.lastName);
        setEmail(resData.email);
        setPhone(resData.phone);
        setCity(resData.city);
        setState(resData.state);
        setAbout(resData.about);
        setEducation(resData.specialization);
        setClientId(resData.pcUserId);
        setCreateUserImgUrl(resData.imageUrl);
        setDegree(resData.degree);
      }
    });
  };

  useEffect(() => {
    getProfile();
  }, []);

  const onChange = (info) => {
    setImage(info.file.originFileObj);
    let formData = new FormData();
    formData.append("file", info.file.originFileObj);
    dispatch(uploadFile(formData)).then((res) => {
      if (res.payload.status === "success") {
        setCreateUserImgUrl(res.payload.message.payload);
        setCreateImage(res.payload.message.payload);
        setUserImage(res.payload.message.payload);
      } else {
        message.error("Something went wrong while uploading image");
      }
    });
  };

  return (
    <Container fluid className="parent-container">
      <Row>
        <Col md={12} style={{ marginTop: "90px" }}>
          <Container>
            <Container
              className="upload-data-box"
              style={{ minHeight: "350px" }}
            >
              <Row>
                <Col md={7}>
                  <Form
                    form={form}
                    name="complex-form"
                    layout="vertical"
                    onFinish={onFinish}
                    labelCol={{
                      span: 32,
                    }}
                    wrapperCol={{
                      span: 32,
                    }}
                  >
                    <Form.Item name="userId">
                      <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <Form.Item
                        label="Firstname"
                        name="firstname"
                        rules={[
                          {
                            required: true,
                            message: "Firstname is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                        }}
                      >
                        <Input
                          placeholder="Enter Firstname"
                          className="profile_input"
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Last Name"
                        name="lastname"
                        rules={[
                          {
                            required: true,
                            message: "Lastname is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                          margin: "0 8px",
                        }}
                      >
                        <Input
                          placeholder="Enter Lastname"
                          className="profile_input"
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </Form.Item>
                    </Form.Item>
                    <Form.Item
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <Form.Item
                        label="Email ID"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Email is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                        }}
                      >
                        <Input
                          placeholder="Enter Email ID"
                          className="profile_input"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Phone Number"
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message: "Phone number is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                          margin: "0 8px",
                        }}
                      >
                        <Input
                          placeholder="Enter Phone Number"
                          className="profile_input"
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </Form.Item>
                    </Form.Item>
                    <Form.Item
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <Form.Item
                        label="City"
                        name="city"
                        rules={[
                          {
                            required: true,
                            message: "City is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                        }}
                      >
                        <Input
                          placeholder="Enter City"
                          className="profile_input"
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="State"
                        name="state"
                        rules={[
                          {
                            required: true,
                            message: "State is required",
                          },
                        ]}
                        style={{
                          display: "inline-block",
                          width: "calc(50% - 8px)",
                          margin: "0 8px",
                        }}
                      >
                        <Select
                          placeholder="Enter State"
                          className="profile_input"
                          onChange={(value) => setState(value)}
                          options={[
                            {
                              label: "Andaman and Nicobar Islands",
                              value: "Andaman and Nicobar Islands",
                            },
                            {
                              label: "Arunachal Pradesh",
                              value: "Arunachal Pradesh",
                            },
                            {
                              label: "Andhra Pradesh",
                              value: "Andhra Pradesh",
                            },
                            {
                              label: "Arunachal Pradesh",
                              value: "Arunachal Pradesh",
                            },
                            {
                              label: "Assam",
                              value: "Assam",
                            },
                            {
                              label: "Bihar",
                              value: "Bihar",
                            },
                            {
                              label: "Chandigarh",
                              value: "Chandigarh",
                            },
                            {
                              label: "Chhattisgarh",
                              value: "Chhattisgarh",
                            },
                            {
                              label: "Dadra and Nagar Haveli and Daman and Diu",
                              value: "Dadra and Nagar Haveli and Daman and Diu",
                            },
                            {
                              label: "Delhi",
                              value: "Delhi",
                            },
                            {
                              label: "Goa",
                              value: "Goa",
                            },
                            {
                              label: "Gujarat",
                              value: "Gujarat",
                            },
                            {
                              label: "Haryana",
                              value: "Haryana",
                            },
                            {
                              label: "Himachal Pradesh",
                              value: "Himachal Pradesh",
                            },
                            {
                              label: "Jammu and Kashmir",
                              value: "Jammu and Kashmir",
                            },
                            {
                              label: "Jharkhand",
                              value: "Jharkhand",
                            },
                            {
                              label: "Karnataka",
                              value: "Karnataka",
                            },
                            {
                              label: "Kerala",
                              value: "Kerala",
                            },
                            {
                              label: "Ladakh",
                              value: "Ladakh",
                            },
                            {
                              label: "Lakshadweep",
                              value: "Lakshadweep",
                            },
                            {
                              label: "Madhya Pradesh",
                              value: "Madhya Pradesh",
                            },
                            {
                              label: "Maharashtra",
                              value: "Maharashtra",
                            },
                            {
                              label: "Manipur",
                              value: "Manipur",
                            },
                            {
                              label: "Meghalaya",
                              value: "Meghalaya",
                            },
                            {
                              label: "Mizoram",
                              value: "Mizoram",
                            },
                            {
                              label: "Nagaland",
                              value: "Nagaland",
                            },
                            {
                              label: "Odisha",
                              value: "Odisha",
                            },
                            {
                              label: "Puducherry",
                              value: "Puducherry",
                            },
                            {
                              label: "Punjab",
                              value: "Punjab",
                            },
                            {
                              label: "Rajasthan",
                              value: "Rajasthan",
                            },
                            {
                              label: "Sikkim",
                              value: "Sikkim",
                            },
                            {
                              label: "Tamil Nadu",
                              value: "Tamil Nadu",
                            },
                            {
                              label: "Telangana",
                              value: "Telangana",
                            },
                            {
                              label: "Tripura",
                              value: "Tripura",
                            },
                            {
                              label: "Uttar Pradesh",
                              value: "Uttar Pradesh",
                            },
                            {
                              label: "Uttarakhand",
                              value: "Uttarakhand",
                            },
                            {
                              label: "West Bengal",
                              value: "West Bengal",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Form.Item>
                    <Form.Item></Form.Item>
                  </Form>
                </Col>
                <Col
                  md={5}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="image-picker-container">
                    <div
                      style={{
                        width: "110px",
                        position: "relative",
                        display: "flex",
                      }}
                    >
                      <Image src={userImage} className="user-image" />
                      <Upload
                        onChange={onChange}
                      //  fileList={["png", "jpg", "jpeg"]}
                      >
                        <Button
                          icon={
                            <Image
                              src={edit_profile_icon}
                              style={{ width: "25px", height: "25px" }}
                            />
                          }
                          className="upload_button"
                        />
                      </Upload>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <Container
              className="upload-data-box"
              style={{ minHeight: "158px" }}
            >
              <h4 className="about-heading">About Yourself</h4>
              <Form
                form={messageForm}
                name="complex-form"
                layout="vertical"
                onFinish={onFinish}
                labelCol={{
                  span: 32,
                }}
                wrapperCol={{
                  span: 32,
                }}
              >
                <Form.Item name={"about"}>
                  <Input.TextArea
                    placeholder={
                      "Write about you, your years of experience..............."
                    }
                    style={{
                      borderWidth: "0px",
                      outline: "none",
                    }}
                    onChange={(e) => setAbout(e.target.value)}
                  ></Input.TextArea>
                </Form.Item>
              </Form>
            </Container>
            <Container
              className="upload-data-box"
              style={{ minHeight: "158px" }}
            >
              <h4 className="about-heading">Specialization</h4>
              <Form
                form={educationForm}
                name="complex-form"
                layout="vertical"
                onFinish={onFinish}
                labelCol={{
                  span: 32,
                }}
                wrapperCol={{
                  span: 32,
                }}
              >
                <Form.Item>
                  <Form.Item
                    name={"education"}
                    style={{
                      display: "inline-block",
                      width: "calc(30% - 8px)",
                    }}
                    label={"Specialiazation"}
                  >
                    {/* <Input
                    placeholder={""}
                    style={{
                      width: "30%",
                      height: "45px",
                    }}
                    onChange={(e) => setEducation(e.target.value)}
                  ></Input> */}
                    <Select
                      options={[
                        {
                          label: "Counsellor",
                          value: "Counsellor",
                        },
                        {
                          label: "Coach",
                          value: "Coach",
                        },
                        {
                          label: "Doctor",
                          value: "Doctor",
                        },
                        {
                          label: "Psychologist",
                          value: "Psychologist",
                        },
                      ]}
                      style={{
                        width: "100%",
                        height: "45px",
                      }}
                      onChange={(v) => setEducation(v)}
                    />
                  </Form.Item>
                  <Form.Item
                    name={"degree"}
                    label={"Degree"}
                    style={{
                      display: "inline-block",
                      width: "calc(30% - 8px)",
                      marginLeft: "10px",
                      minHeight: "50px !important",
                    }}
                  >
                    {/* <Input
                    placeholder={""}
                    style={{
                      width: "30%",
                      height: "45px",
                    }}
                    onChange={(e) => setEducation(e.target.value)}
                  ></Input> */}
                    <Select
                      options={[
                        {
                          label: "MBBS",
                          value: "MBBS",
                        },
                        {
                          label: "MD",
                          value: "MD",
                        },
                        {
                          label: "MS",
                          value: "MS",
                        },
                        {
                          label: "Clinical Psychology",
                          value: "Clinical Psychology",
                        },
                        {
                          label: "Counseling Psychology",
                          value: "Counseling Psychology",
                        },
                        {
                          label: "Rehabilitation Counseling",
                          value: "Rehabilitation Counseling",
                        },
                        {
                          label: "Diploma Psychology",
                          value: "Diploma Psychology",
                        },
                      ]}
                      style={{
                        width: "100%",
                      }}
                      mode="multiple"
                      onChange={(v) => setDegree(v)}
                    />
                  </Form.Item>
                </Form.Item>
              </Form>
            </Container>

            <Container
              style={{
                padding: 0,
                display: "flex",

                marginBottom: "50px",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <Button className="update-btn" onClick={() => updateData()}>
                Update
              </Button>
            </Container>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}
